import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton } from "kahuna-base-react-components"
import React from "react"
import { lang } from "../../../constants/languages"

const ConfirmationDialog = ({
  openConfirmation,
  setOpenConfirmation,
  handleConfirm,
  loading,
  overrideDescription
}: {
  openConfirmation: boolean
  setOpenConfirmation: React.Dispatch<React.SetStateAction<boolean>>
  handleConfirm: () => void
  loading: boolean
  overrideDescription?: string
}) => {
  return (
    <Dialog
      open={openConfirmation}
      onClose={() => {
        setOpenConfirmation(false)
      }}
    >
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md w-[400px] rounded-[10px] bg-[#fff]">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-8 items-center justify-center">
              <span className="w-[96px] aspect-square rounded-[48px] shadow-md flex justify-center items-center">
                <img className="w-12 h-12" src="/account_icons/error.svg"></img>
              </span>
              <KTitleSpan text={lang.common.confirm_dialog.title} fontSize={24} lineHeight="32px" />
              <div className="flex" style={{ textAlign: "center" }}>
                <KSpan text={overrideDescription || lang.common.confirm_dialog.desc} />
              </div>
            </div>
            <div className="flex gap-3 justify-center items-center">
              <KButton
                dataTestId="cancel-confirmation-button"
                text={lang.common.cancel}
                onClick={() => {
                  setOpenConfirmation(false)
                }}
                background="#fff"
                shadowDisabled={true}
              />
              <KButton
                dataTestId="confirm-action-button"
                text={lang.common.confirm}
                textColor="white"
                background="black"
                disabled={loading}
                onClick={() => {
                  handleConfirm()
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ConfirmationDialog
